export default __webpack_public_path__ + "static/media/mask.21a522ed.svg";